import React, { useEffect, useState } from "react";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { fetchData, postData } from "../../../Services/GlobalService";
import { toast } from "react-toastify";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";
import * as Fa from "react-icons/fa";
import { downloadExcelDateStringFormat } from "../../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";

const UniqueBeatID = () => {
  const ControllerName = "masters/Distributer/TownDistMap_ReHistory";
  const ControllerCust = "masters/Customer/CustomerMaster";
  const ControllerContract = "Reports/ContractPricing";
  const controllerUniqueId = "masters/Customer/CustUniqueIdReport"

  const EndPoint = {
    CustomerMasterExcel: "CustomerMasterExcel",
    GetAllDistributorType: "GetAllDistributorType",
    PopulateDivision: "PopulateDivision",
    PopulateRegion: "PopulateRegion",
    PopulateState: "PopulateState",
    PopulateAllDistributor: "PopulateAllDistributor",
    GetTwnDistMappedExcel: "GetTwnDistMappedExcel",
    GetFilteredDistributorData2: "GetFilteredDistributorData2",
    GetAllDistributorData2: "GetAllDistributorData2", 
    GetFinYear: "GetFinYear",
    DownloadReport: "DownloadReport"
  };
  const UserId = localStorage.getItem("UserId")?.toString();
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [region, setRegion] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);

  const [distType, setDistType] = useState([]);
  const [selectedDistType, setSelectedDistType] = useState<any>([]);
  const [fromdate, setFromdate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();
  const [maxDate, setMaxDate] = useState<Date>(new Date());
  const [minDate, setMinDate] = useState<Date>(new Date());
  const [division, setDivision] = useState<any>([]);
  const [selectedDistList, setSelectedDistList] = useState([]);
  const [allDistributorList, setallDistributorList] = useState([]);

  useEffect(() => {
    const pageLoad = async () => {
      try {
        let PopulateDistTypeRes = await fetchData(
          ControllerCust,
          `${EndPoint.GetAllDistributorType}`,
          `UserId=${UserId}`
        );
        let PopulateRgnRes = await fetchData(
          ControllerName,
          `${EndPoint.PopulateRegion}`,
          `UserId=${UserId}`
        );
        let PopulateDivRes = await fetchData(
          ControllerName,
          `${EndPoint.PopulateDivision}`,
          `UserId=${UserId}`
        );
        let PopulateAllDistributorRes = await fetchData(
          ControllerContract,
          `${EndPoint.GetFilteredDistributorData2}`,
          `PVCDivisionId=${PopulateDivRes.Data[0].MASK_DIVN_ID}&PVCStateId=ALL&PVCRegionId=ALL&PVCUserId=${UserId}&PVCDistributor=Automotive`
        );

        let PopulateStateRes = await fetchData(
          ControllerName,
          `${EndPoint.PopulateState}`,
          `UserId=${UserId}&strRegionId=All`
        );

        let PopulateFinYearRes = await fetchData(
          ControllerCust,
          `${EndPoint.GetFinYear}`,
          ``
        );
        setFromdate(new Date(PopulateFinYearRes.Data[0]?.FINYEAR_START));
        setToDate(new Date(PopulateFinYearRes.Data[0]?.FINYEAR_END));
        setallDistributorList(PopulateAllDistributorRes.Data);
        setDivision(PopulateDivRes.Data);
        setRegion(PopulateRgnRes.Data);
        setSelectedRegion(PopulateRgnRes.Data);
        setState(PopulateStateRes.Data);
        setSelectedState(PopulateStateRes.Data);
        setDistType(PopulateDistTypeRes.Data);
        setSelectedDistType(PopulateDistTypeRes.Data[1]);
      } catch (error) {
        console.log("Error", error);
      }
    };
    pageLoad();
  }, []);

  const handleDownload = async () => {
    // const dbCodes = selectedDistList?.map((item: any) => item?.COMP_ID);
    let strDistIds = selectedDistList?.map((item: any) => `${item.COMP_ID}`).join(",");
    try {
      setLoadingExcel(true);
      let excelReqPayload = {
        PVCCOMP_ID: strDistIds.toString(),
        PVCSTART_DATE: format(fromdate ?? "", "dd/MM/yyyy"),
        PVCEND_DATE: format(toDate ?? "", "dd/MM/yyyy"),
      };
      let CustomerExcelReqRes = await postData(
        controllerUniqueId,
        `${EndPoint.DownloadReport}`,
        excelReqPayload
      );
      toast.success(`${CustomerExcelReqRes.Message}`);
      downloadExcelDateStringFormat(CustomerExcelReqRes.Data,`Customer_Unique_Id_Report_${GetDateFormat()}.xlsx`);
      console.log("excelReqPayload",excelReqPayload);
      setSelectedDistList([]);
    } catch (error: any) {
      toast.error(`${error.response.data.Message}`);
      setSelectedDistList([]);
    }
    finally{
      setLoadingExcel(false);
    }
  };
  const handleRequest = async () => {
          const dbCodes = selectedDistList?.map((item: any) => item?.COMP_ID);
          try {
              let excelReqPayload = {
                  viN_REQID: `${format(new Date(), "yyyyMMddhhmmss")}_${generateRandomNo()}`,
                  viN_USRID: UserId,
                  viN_DIST_CODE: dbCodes.toString(),
                  viN_STARTDATE: format(fromdate ?? "", "dd/MM/yyyy"),
                  viN_ENDATE: format(toDate ?? "", "dd/MM/yyyy"),
                  viN_CUST_TAG: "UIR",
                  viN_COUNT: ""
              }
              let CustomerExcelReqRes = await postData(ControllerCust,
                  `${EndPoint.CustomerMasterExcel}`, excelReqPayload
              )
              toast.success(`${CustomerExcelReqRes.Message}`);
              setSelectedDistList([]);
          }
          catch (error: any) {
              toast.error(`${error.response.data.Message}`)
              setSelectedDistList([]);
  
          }
      }

  function generateRandomNo(): number {
    const min = 1000;
    const max = 9999;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const handleRegion = async (e: MultiSelectChangeEvent) => {
    const selectedRegions = e.value as [];
    setSelectedRegion(e.value);
    const selectedregionValus = selectedRegions
      .map((item: any) => `${item.MASK_ID}`)
      .join(",");
    setSelectedState([]);
    stateCallfun(selectedregionValus === "" ? "All" : selectedregionValus);
  };

  const stateCallfun = async (selectedregionValus: string) => {
    let PopulateStateRes = await fetchData(
      ControllerName,
      `${EndPoint.PopulateState}`,
      `UserId=${UserId}&strRegionId=${selectedregionValus}`
    );
    setState(PopulateStateRes.Data);
    setSelectedState(PopulateStateRes.Data);
    const selectedStates = PopulateStateRes.Data.map(
      (item: any) => `${item.mask_id}`
    ).join(",");
    let PopulateAllDistributorRes = await fetchData(
      ControllerContract,
      `${EndPoint.GetFilteredDistributorData2}`,
      `PVCDivisionId=${division[0].MASK_DIVN_ID}&PVCStateId=${selectedStates}&PVCRegionId=${selectedregionValus}&PVCUserId=${UserId}&PVCDistributor=Automotive`
    );
    setallDistributorList(PopulateAllDistributorRes.Data);
  };

  const handleState = async (e: MultiSelectChangeEvent) => {
    setSelectedState(e.value);
    const selectedregionValus = selectedRegion
      .map((item: any) => `${item.MASK_ID}`)
      .join(",");
    const selectedStates = e.value
      .map((item: any) => `${item.mask_id}`)
      .join(",");
    let PopulateAllDistributorRes = await fetchData(
      ControllerContract,
      `${EndPoint.GetFilteredDistributorData2}`,
      `PVCDivisionId=${division[0].MASK_DIVN_ID}&PVCStateId=${selectedStates}&PVCRegionId=${selectedregionValus}&PVCUserId=${UserId}&PVCDistributor=Automotive`
    );
    setallDistributorList(PopulateAllDistributorRes.Data);
  };

  const handleDistributorChange = async (e: DropdownChangeEvent) => {
    const selectedregionValus = selectedRegion
      .map((item: any) => `${item.MASK_ID}`)
      .join(",");
    const selectedStates = selectedState
      .map((item: any) => `${item.mask_id}`)
      .join(",");
    setSelectedDistType(e.value);
    let PopulateAllDistributorRes = await fetchData(
      ControllerContract,
      `${EndPoint.GetFilteredDistributorData2}`,
      `PVCDivisionId=${division[0].MASK_DIVN_ID}&PVCStateId=${selectedStates}&PVCRegionId=${selectedregionValus}&PVCUserId=${UserId}&PVCDistributor=Automotive`
    );
    setallDistributorList(PopulateAllDistributorRes.Data);
  };

  return (
    <>
      <main>
        <div className="col-12 mb-5">
          <div className="row">
            {/* Breadcrumb  */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <nav aria-label="breadcrumb" className="drop-in">
                <ol className="breadcrumb mx-0">
                  <li className="breadcrumb-item">Customer</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Unique Beat ID
                  </li>
                </ol>
              </nav>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">Unique Beat ID</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12"></div>
          </div>

          <section>
            <div className="row">
              <div className="col-lg-5 col-md-12 col-sm-12">
                <div className="sales-box">
                  <form>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="d-block mb-2">
                        <label className="form-label">Region</label>
                        <MultiSelect
                          value={selectedRegion}
                          onChange={(e) => handleRegion(e)}
                          options={region}
                          selectAllLabel="Select All"
                          optionLabel="REGION_DESC"
                          placeholder="Select Region"
                          className="w-100"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="d-block mb-2">
                        <label className="form-label">State</label>
                        <MultiSelect
                          value={selectedState}
                          onChange={(e) => handleState(e)}
                          options={state}
                          optionLabel="GEOG_DESC1"
                          placeholder="Select State"
                          className="w-100"
                          selectAllLabel="Select All"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="d-block mb-2">
                        <label className="form-label">Distributor Type</label>
                        <Dropdown
                          value={selectedDistType}
                          options={distType}
                          onChange={handleDistributorChange}
                          optionLabel="DIST"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <label className="form-label">From Date</label>
                          <Calendar
                            value={fromdate}
                            onChange={(e) => setFromdate(e.value as Date)}
                            showIcon
                            dateFormat="dd/mm/yy"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-block mb-2">
                          <label className="form-label">To Date</label>
                          <Calendar
                            value={toDate}
                            onChange={(e) => setToDate(e.value as Date)}
                            showIcon
                            dateFormat="dd/mm/yy"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="text-end mt-2">
                        <button
                          type="button"
                          className="btn anime-btn"
                          onClick={() => {
                            if (selectedDistList.length == 0) {
                              toast.error(
                                "Please select at least one Distributor."
                              );
                            }else{
                              handleRequest();
                            }
                          }}
                          disabled={loadingExcel}
                        >
                          {loadingExcel ? "Loading..." : "Request Report"}{" "}
                    {loadingExcel ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <Fa.FaDownload className="ms-2" />
                    )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="">
                  <div className="DataTable">
                    <DataTable
                      value={allDistributorList}
                      rows={10}
                      rowsPerPageOptions={[10, 25, 50]}
                      filterDisplay="row"
                      showGridlines
                      stripedRows
                      scrollHeight="60vh"
                      scrollable
                      paginator
                      selection={selectedDistList}
                      onSelectionChange={(e) => setSelectedDistList(e.value)}
                      selectionMode="checkbox"
                    >
                      <Column
                        selectionMode="multiple"
                        header="Select All"
                        headerStyle={{ width: "5rem" }}
                      ></Column>
                      <Column
                        field="COMP_NAME"
                        header="List of Distributors"
                        filter
                        filterMatchMode="contains"
                        filterPlaceholder="Search Here..."
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default UniqueBeatID;
